import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mapKeys, omit } from 'lodash-es';
import type { Location } from '../../types';

type LocationState = Record<number, Location>;

const initialState: LocationState = {};

const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocations(state, action: PayloadAction<Location[]>) {
      return mapKeys(action.payload, 'id') as unknown as LocationState;
    },
    pushLocation(state, action: PayloadAction<Location>) {
      state[action.payload.id] = action.payload;
    },
    deleteLocation(state, action: PayloadAction<{ id: number }>) {
      return omit(state, action.payload.id) as LocationState;
    },
  },
});

export const { setLocations, pushLocation, deleteLocation } = locationSlice.actions;
export default locationSlice.reducer;
